import { setToken } from '../../utils/auth';
import { validatNumberAndChart } from '../../common/validate';
// import {mobileLogin,getUserInfoAjax} from '@/api/baseMsg';
import { getVerifyCodeImg } from '@/api/user';
import { encryptedData } from '../../utils/JSEncrypt';
import config from '@/config/index';
import $axios from 'axios';
import { asyncRoutes } from '@/router';
import smsView from '../login/sms.vue';

export default {
  name: 'loginOld',
  components: { smsView },
  data() {
    return {
      onloadHeight: 0,
      isflooerTop: '92%',
      loginForm: {
        username: '',
        password: '',
        checkVerification: '',
        usernameEncry: '',
        passwordEncry: '',
        uuid: '',
        phone: ''
      },
      focus: {
        field: '',
        isTop: false,
        userFocus: false,
        pwdFocus: false,
        codeFocus: false
      },
      error_message: '',
      userId: this.$route.query.userId ? this.$route.query.userId : '',
      code: this.$route.query.code ? this.$route.query.code : '',
      userName: this.$route.query.userName ? this.$route.query.userName : '',
      imgUrl: null,
      passwordType: 'password',
      smsPopup: {
        show: false
      }
    };
  },
  mounted() {
    // this.getInfo()  //获取用户信息
    this.yzmClick();
    this.$nextTick(() => {
      this.getContentHeader();
      this.onloadHeight = document.body.clientHeight;
    });
    window.addEventListener('resize', this.getViewHeight);
  },
  methods: {
    getViewHeight() {
      const curHeight = window.innerHeight;
      if (curHeight < this.onloadHeight - 10) {
        this.focus.isTop = true;
        this.$nextTick(() => {
          this.$refs[this.focus.field].focus();
        });
      } else {
        this.focus.isTop = false;
        this.focus.field = '';
      }
    },
    handleInputFocus(field) {
      setTimeout(() => {
        this.$refs[field].focus();
      }, 100);
    },
    // 获取内容高度
    getContentHeader() {
      const h1 = this.$refs.ref_header_pla.clientHeight;
      const h2 = this.$refs.ref_header_title.clientHeight;
      const h3 = this.$refs.ref_header_form.clientHeight;
      this.$set(this, 'isflooerTop', h1 + h2 + h3 + 38 + 'px');
    },

    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
      const field = this.focus.field;
      if (field) {
        this.$nextTick(() => {
          this.$refs.ref_login_pwd.focus();
          this.focus.field = field;
        });
      }
    },
    // 用户名-密码-验证码登录
    handleLogin() {
      if (!this.loginForm.username) {
        return this.isClick();
      }
      if (!this.loginForm.password) {
        return this.isClickP();
      }
      if (!this.loginForm.checkVerification) {
        return this.isClickV();
      }
      this.loginForm.usernameEncry = encryptedData(this.loginForm.username); // 加密数据
      this.loginForm.passwordEncry = encryptedData(this.loginForm.password); // 加密数据
      const params = {
        // type:8082,
        password: this.loginForm.passwordEncry,
        username: this.loginForm.usernameEncry,
        verifyCode: this.loginForm.checkVerification,
        uuid: this.loginForm.uuid
        // type: 8082
      };
      $axios({
        method: 'post',
        url: config.devProxy + '/zdcommon/mobileLogon/logon',
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        console.log('res', res);
        if (res.data.code == 200) {
          setToken(res.data.data.token);
          this.$store.commit('login/SET_LOGINUSERFORM', this.loginForm.username);
          this.$store.commit('SET_LOGINUSERFORM', this.loginForm.username);
          this.$store.commit('SET_NAME', this.loginForm.username);

          this.$store.commit('login/SET_LOGINTYPE', 2);
          // this.getInfo()
          // 1工作人员，0监测点
          this.$store.dispatch('getListTreeFuns').then((res1) => {
            const data = res1.data;
            this.$store.dispatch('permissionFuns/generateRoutes', data).then((res2) => {
              res2.forEach((i) => {
                asyncRoutes.push(i);
              });
              const resultRouter = asyncRoutes;
              this.$router.addRoutes(resultRouter);
              if (res.data.data.ifSystem == 1) {
                this.$router.push({ path: '/' });
              } else {
                this.$router.push({ path: '/jiagecaijiTB/jiagecaiji' });
              }
            });
          });
        } else if (res.data.code == 513) {
          // 双因子登录
          this.loginForm.phone = res.data.data;
          this.smsPopup.show = true;
        } else if (res.data.code == 511 || res.data.code == 503) {
          // 验证码错误、账号被锁定
          // this.loginForm.password = ''
          // this.loginForm.passwordEncry = ''
          this.loginForm.checkVerification = '';
          this.loginForm.uuid = '';
          this.yzmClick();
          this.error_message = res.data.message || '登录失败';
          // nativeJSBridge.logout();
        } else {
          // 密码错误
          this.loginForm.password = '';
          this.loginForm.passwordEncry = '';
          this.loginForm.checkVerification = '';
          this.loginForm.uuid = '';
          this.yzmClick();
          this.error_message = res.data.message || '登录失败';
        }
      });
      // mobileLogin(JSON.stringify({
      // userName: this.loginForm.usernameEncry,
      // passWord: this.loginForm.passwordEncry,
      // })).then(res => {
      //     // console.log(res)
      //     if(res.code === 200){
      //         this.$store.dispatch('login',this.loginForm)
      //         .then(() => {
      //                 setToken(res.data.token)
      //                 this.getInfo()
      //                 sessionStorage.setItem('loginUserForm', this.loginForm.username);
      //                 this.$router.push({ path: '/'});
      //             })
      //     }else{
      //         // this.yzmClick();
      //         this.loginForm.password = ''
      //         this.loginForm.checkVerification = ''
      //         this.loginForm.passwordEncry = ''
      //         // Toast(res.message);
      //         // Toast("监测点用户不可登录此App");
      //         setTimeout(() => {
      //             Toast(res.message);
      //          }, 800);
      //         return;
      //     }
      // })
    },
    isClick() {
      if (!this.loginForm.username) {
        this.error_message = '请输入账号!';
      } else {
        this.error_message = '';
      }
    },
    isClickV() {
      if (!this.loginForm.checkVerification) {
        this.error_message = '请输入验证码！';
      } else {
        this.error_message = '';
      }
    },
    isClickP() {
      if (!this.loginForm.password) {
        this.error_message = '请输入密码！';
      } else {
        this.error_message = '';
      }
    },
    // 点击验证码图片
    yzmClick() {
      getVerifyCodeImg().then((res) => {
        if (res.code == 200) {
          this.imgUrl = 'data:image/png;base64,' + res.data.imgBytes;
          this.loginForm.uuid = res.data.uuid;
        }
      });
    },
    // 获取用户信息
    getInfo() {
      const params = {
        username: this.loginForm.usernameEncry
      };
      $axios({
        method: 'post',
        url: config.devProxy + '/mobile/mobileLogon/checkLogin',
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(() => {});
    },
    removeToken() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ path: '/loginOld' });
      });
    },
    // 订阅于提醒
    isDingYue() {
      Toast('不支持订阅，请在小程序内打开！');
    },
    onClickCloseIcon() {
      this.yzmClick();
      this.loginForm.password = '';
      this.loginForm.checkVerification = '';
      this.loginForm.passwordType = 'password';
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getViewHeight);
  }
};
